import * as React from 'react';
type Props = {
  className?: string;
};
export function Tomatoes({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Tomatoes"
      className={className}
    >
      <path
        d="M12.4101 12.55H29.1201M16.3101 17.04L20.7601 12.55M20.7601 12.55V7M20.7601 12.55L25.2201 17.04M20.4701 10.94C19.0501 11.05 16.3501 9.33002 14.2401 8.83002C12.3898 8.45781 10.4703 8.64946 8.73009 9.38006C6.84249 10.1025 5.22797 11.397 4.11266 13.0826C2.99734 14.7681 2.43695 16.7602 2.50999 18.78C2.68991 20.7214 3.25795 22.6071 4.1804 24.3249C5.10286 26.0427 6.36092 27.5576 7.87999 28.78C12.88 32.78 20.59 33.1701 26.67 31.8701C32.35 30.6501 36.3501 27.0001 37.7401 21.6201C38.4433 18.953 38.1957 16.1244 37.04 13.6201C36.4153 12.2835 35.4789 11.1164 34.3096 10.2167C33.1402 9.31711 31.7721 8.71124 30.3201 8.45001C28.5506 8.08129 26.7106 8.26637 25.05 8.98004C23.51 9.63004 21.8601 11.05 20.4701 10.94Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
    </svg>
  );
}
